import _extends from "babel-runtime/helpers/extends";
import _classCallCheck from "babel-runtime/helpers/classCallCheck";
import _possibleConstructorReturn from "babel-runtime/helpers/possibleConstructorReturn";
import _inherits from "babel-runtime/helpers/inherits";
import * as React from 'react';
var LazyRenderBox = function (_React$Component) {
  _inherits(LazyRenderBox, _React$Component);
  function LazyRenderBox() {
    _classCallCheck(this, LazyRenderBox);
    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }
  LazyRenderBox.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    return !!nextProps.hiddenClassName || !!nextProps.visible;
  };
  LazyRenderBox.prototype.render = function render() {
    var className = this.props.className;
    if (!!this.props.hiddenClassName && !this.props.visible) {
      className += " " + this.props.hiddenClassName;
    }
    var props = _extends({}, this.props);
    delete props.hiddenClassName;
    delete props.visible;
    props.className = className;
    return React.createElement("div", _extends({}, props));
  };
  return LazyRenderBox;
}(React.Component);
export default LazyRenderBox;